import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
//import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import { APP_TITLE } from '../../shared/constants'

const hrStyle = {
  margin: '0px !important',
  borderTop: '0px',
}

const navStyle = {
  margin: '0px !important',
  borderBottom: '1px solid #d9d9d9',
}

class LoggedoutHeader extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <Fragment><nav className="navbar navbar-expand-lg navbar-light bg-white navbar-fixed-top" style={navStyle}><div className="container"><a href="/" className="navbar-brand">{APP_TITLE}</a><div className="collapse navbar-collapse" id="navbarSupportedContent"><ul className="navbar-nav ml-auto"><li className="nav-item btn-group"><a className="nav-link" href="#">Hello!</a></li></ul></div></div></nav><hr style={hrStyle} /></Fragment>
  }
}

export default LoggedoutHeader
